// @flow

import * as Immutable                from 'immutable';
import Cookies                       from 'js-cookie';
import type { Middleware }           from 'redux';
import configureGoogleAnalytics      from '../../analytics/google-analytics/configureGoogleAnalytics';
import { selectIsCookieTypeEnabled } from '../../selectors/cookieSettingsSelectors';
import type { State }                from '../../store';


// -----------------------------------------------------------------------------------------------------------------
// Config
// -----------------------------------------------------------------------------------------------------------------

const gaCookieNames = [
  /^_g(a|id)$/,
  /^_gat_gtag_/,
];


// -----------------------------------------------------------------------------------------------------------------
// Middleware
// -----------------------------------------------------------------------------------------------------------------

/**
 * @return {function(<IsPersonalisedAction>): Function}
 *
 * @todo $FlowFixMe
 */
const googleAnalyticsMiddleware: Middleware<State, *> = (store) => {

  return function (next) {

    return function (action) {

      const isEnabledBefore = selectIsCookieTypeEnabled(store.getState(), {cookieType: 'analytics'});

      const result = next(action);

      const isEnabledAfter = selectIsCookieTypeEnabled(store.getState(), {cookieType: 'analytics'});

      if (isEnabledBefore !== isEnabledAfter) {
        toggleCookies(isEnabledAfter);
      }

      return result;

    };

  };

};


// -----------------------------------------------------------------------------------------------------------------
// Helper functions
// -----------------------------------------------------------------------------------------------------------------

function toggleCookies(isEnabledNow: boolean) {
  if (isEnabledNow) {
    configureGoogleAnalytics();
    return;
  }

  const cookiesToRemove = Immutable.Map(Cookies.get()).keySeq().filter(
    (cookieName: string) => Immutable.List(gaCookieNames).reduce((include, gaCookieName: RegExp) => {
      if (!include && gaCookieName.test(cookieName)) {
        return true;
      }

      return include;
    }, false),
  );

  cookiesToRemove.forEach((cookieName: string) => {
    Cookies.remove(cookieName, {domain: `.${window.location.hostname}`, path: '/'});
  });
}


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default googleAnalyticsMiddleware;



// WEBPACK FOOTER //
// ./src/store/middleware/googleAnalyticsMiddleware.js